import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import moment from "moment"
import copy from "./directive/v-copy/directives"
// 指令
import permission from './directive/permission'
// 路由及权限
import './permission' // permission control
// 全局样式
import Element from 'element-ui'
import './styles/element-variables.scss'
import './styles/index.scss' // global css
import './styles/element-ui.scss' // global css
//
//
Vue.directive('permission', permission)
//
Vue.use(Element, {
    size: VueCookies.get('size') || 'medium' // set element-ui default size
})
//
//
Vue.use(VueCookies)
Vue.use(copy)
Vue.prototype.$moment = moment
Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app')
